import { useMemo } from 'react';
import { ChatMessage, User } from '../types';

export function calculateAuthors(messages: ChatMessage[]) {
  const authors: User[] = [];
  const seenAuthors: Set<string> = new Set();
  for (const message of messages) {
    if (message.user && !seenAuthors.has(message.user.userUuid)) {
      authors.push(message.user);
      seenAuthors.add(message.user.userUuid);
    }
  }
  return authors;
}

export function useAuthors(messages: ChatMessage[]) {
  const authors = useMemo(() => {
    return calculateAuthors(messages);
  }, [messages]);
  return authors;
}
